import BaseComponent from "./BaseComponent";
import Slider from "rc-slider";

export default class BasicSlider extends BaseComponent {
    /**
     * Slider to select integer
     * @module BasicSlider
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.state = {
            label: this.props.label ? this.props.label : "",
            value: this.props.value ? this.props.value : 0
        };
    }

    handleChange(value){
        this.updateContext(value);
        this.setState({ ...this.state, value: value })
    }
   
    render(){
        return (
            <div className={"form-component-container"}>
                <label>{this.state.label}: {this.state.value}{this.props.labelSuffix ? this.props.labelSuffix : ""}</label>
                <Slider 
                    min={this.props.min} 
                    max={this.props.max} 
                    defaultValue={this.props.value ? this.props.value : 0} 
                    onChange={(value) => this.handleChange(value)}
                    disabled={!this.props.enabled}
                />
            </div>
        );
    }
}
